import React, {  } from 'react';

const MyAccount = (props) => {
    return (
        <>
            <div className="kt-subheader kt-grid__item">
                <div className="kt-container">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Account Settings</h3>
                    </div>
                </div>

            </div>
        </>
    );
}
export default MyAccount;